"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var GraphQL = require("graphql");
function addFields(query, fieldNames) {
    // When using visit() to edit an AST, the original AST will not be modified,
    // and a new version of the AST with the changes applied will be returned from the visit function.
    return GraphQL.visit(query, {
        SelectionSet: {
            leave: function (node, _key, _parent, _path) {
                // @return
                //   undefined: no action
                //   false: no action
                //   visitor.BREAK: stop visiting altogether
                //   null: delete this node
                //   any value: replace this node with the returned value
                // // Don't add to the top-level selection-set
                // if (parent && parent.kind === GraphQL.Kind.OPERATION_DEFINITION) {
                //   return undefined;
                // }
                var fieldsToAdd = [];
                for (var _i = 0, fieldNames_1 = fieldNames; _i < fieldNames_1.length; _i++) {
                    var fieldName = fieldNames_1[_i];
                    if (!hasField(fieldName)(node.selections)) {
                        var fieldToAdd = createField(fieldName);
                        fieldsToAdd.push(fieldToAdd);
                    }
                }
                if (fieldsToAdd.length > 0) {
                    var newNode = __assign({}, node, { selections: node.selections.concat(fieldsToAdd) });
                    return newNode;
                }
                return false;
            }
        }
    });
}
exports.addFields = addFields;
function hasField(name) {
    return function (selectionSet) {
        return selectionSet
            .filter(function (s) { return s.kind === "Field"; })
            .some(function (_a) {
            var value = _a.name.value;
            return value === name;
        });
    };
}
function createField(name) {
    return {
        kind: "Field",
        alias: undefined,
        name: {
            kind: "Name",
            value: name
        },
        // tslint:disable-next-line:no-arguments
        arguments: [],
        directives: [],
        selectionSet: undefined
    };
}
//# sourceMappingURL=add-fields.js.map